import {FieldSelectedConfiguration} from "./field-configuration-selected-field/field-configuration-selected-field.model";
export class ActConfiguration {
  selectedFields: FieldSelectedConfiguration[] = [];
}
